const telegram_ik = 'https://t.me/contact2022';
const strategy = 'https://bit.ly/xx2022-org';
export {
    telegram_ik,
    strategy
}
